import React from 'react';
import Icon from '../../../components/AppIcon';

const CollectionTypeSelector = ({ selectedType, onTypeChange }) => {
  const collectionTypes = [
    {
      id: 'vintage-watches',
      name: 'Vintage Watches',
      description: 'Classic timepieces and luxury watches',
      icon: 'Watch',
      color: 'from-blue-500 to-blue-600'
    },
    {
      id: 'sports-cards',
      name: 'Sports Cards',
      description: 'Trading cards, rookie cards, and memorabilia',
      icon: 'CreditCard',
      color: 'from-green-500 to-green-600'
    },
    {
      id: 'comics',
      name: 'Comics',
      description: 'Comic books, graphic novels, and manga',
      icon: 'Book',
      color: 'from-red-500 to-red-600'
    },
    {
      id: 'art-prints',
      name: 'Art Prints',
      description: 'Fine art, prints, and limited editions',
      icon: 'Image',
      color: 'from-purple-500 to-purple-600'
    },
    {
      id: 'stamps',
      name: 'Stamps',
      description: 'Postal stamps and philatelic items',
      icon: 'Mail',
      color: 'from-yellow-500 to-yellow-600'
    },
    {
      id: 'rare-coins',
      name: 'Rare Coins',
      description: 'Numismatic coins and currency',
      icon: 'Coins',
      color: 'from-amber-500 to-amber-600'
    },
    {
      id: 'sneakers',
      name: 'Sneakers',
      description: 'Limited edition and collectible footwear',
      icon: 'ShoppingBag',
      color: 'from-orange-500 to-orange-600'
    },
    {
      id: 'toys',
      name: 'Toys',
      description: 'Action figures, vintage toys, and collectibles',
      icon: 'Gamepad2',
      color: 'from-pink-500 to-pink-600'
    },
    {
      id: 'books',
      name: 'Books',
      description: 'First editions, rare books, and manuscripts',
      icon: 'BookOpen',
      color: 'from-indigo-500 to-indigo-600'
    },
    {
      id: 'other',
      name: 'Other',
      description: 'Custom collectible categories',
      icon: 'Package',
      color: 'from-gray-500 to-gray-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {collectionTypes?.map((type) => (
        <button
          key={type?.id}
          onClick={() => onTypeChange(type?.id)}
          className={`p-6 rounded-lg border-2 transition-all duration-200 text-left hover:shadow-lg ${
            selectedType === type?.id
              ? 'border-primary bg-primary/5 shadow-md'
              : 'border-border bg-card hover:border-primary/50'
          }`}
        >
          <div className="flex items-start space-x-4">
            {/* Icon */}
            <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${type?.color} flex items-center justify-center flex-shrink-0`}>
              <Icon name={type?.icon} size={24} className="text-white" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <h3 className={`font-semibold mb-1 ${
                selectedType === type?.id ? 'text-primary' : 'text-card-foreground'
              }`}>
                {type?.name}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {type?.description}
              </p>
            </div>

            {/* Selection Indicator */}
            {selectedType === type?.id && (
              <div className="flex-shrink-0">
                <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="Check" size={16} className="text-primary-foreground" />
                </div>
              </div>
            )}
          </div>

          {/* Popular Badge for certain types */}
          {['vintage-watches', 'sports-cards', 'comics']?.includes(type?.id) && (
            <div className="absolute top-2 right-2">
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
                Popular
              </span>
            </div>
          )}
        </button>
      ))}
    </div>
  );
};

export default CollectionTypeSelector;